var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4195_3371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 18.3327C14.6022 18.3327 18.3332 14.6017 18.3332 9.99935C18.3332 5.39697 14.6022 1.66602 9.99984 1.66602C5.39746 1.66602 1.6665 5.39697 1.6665 9.99935C1.6665 14.6017 5.39746 18.3327 9.99984 18.3327Z",
    stroke: "#192852",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8335 7.5L10.0002 8.33333M10.0002 8.33333L14.1668 7.5M10.0002 8.33333V10.8333M10.0002 10.8333L8.3335 15M10.0002 10.8333L11.6668 15",
    stroke: "#192852",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 5.83333C9.77008 5.83333 9.5835 5.64678 9.5835 5.41667C9.5835 5.18655 9.77008 5 10.0002 5C10.2302 5 10.4168 5.18655 10.4168 5.41667C10.4168 5.64678 10.2302 5.83333 10.0002 5.83333Z",
    fill: "#192852",
    stroke: "#192852",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4195_3371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessibility);
export default __webpack_public_path__ + "static/media/accessibility.db43eb5d760e667b8287f0f19504bdd7.svg";
export { ForwardRef as ReactComponent };